module.exports = {"140826100":"古绛镇","140826101":"横水镇","140826102":"陈村镇","140826103":"卫庄镇","140826104":"磨里镇","140826105":"南樊镇","140826106":"安峪镇","140826107":"大交镇","140826200":"郝庄乡","140826201":"冷口乡","140826400":"绛县社区","140826402":"山西绛县经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140826.json
// module id = 427
// module chunks = 0